# Currently Not For Code Review
rjm.ui.ChartBuilderTimeOptionsMovingView = Backbone.View.extend(
  events:
    "keydown div.interval input": "filterNonNumeric"
    "click #saveCustomInterval": "save"
    "change div.exclude-interval input": "changeExcludePeriodCount"
    "change div.include-interval input": "changeIncludePeriodCount"
    "change div.include-interval select": "changeIncludeInterval"
    "change div.exclude-interval select": "changeExcludeInterval"

  initialize: (options) ->
    if not options or not options.timeFrameModel or not options.el
      throw "InvalidConstructorArgs - ChartBuilderTimeOptionsMovingView"

    _.bindAll this, "save", "updateValidationModel", "getMovingRangeInputData", "validateTimeRange", "changeExcludePeriodCount", "changeIncludePeriodCount", "changeIncludeInterval", "changeExcludeInterval", "filterNonNumeric", "setMovingRangeInterval", "generateTemplateData", "render"
    @model = options.timeFrameModel
    @validationModel = @model.clone()
    @el = options.el
    return

  save: (e) ->
    @model.set @getMovingRangeInputData()
    @render()
    return

  updateValidationModel: ->
    @validationModel.set @getMovingRangeInputData()

  getMovingRangeInputData: ->
    includePeriodCount: parseInt($('div.include-interval input').val())
    includeInterval: rjm.app.enums.timeInterval[$('div.include-interval select').val()]
    excludePeriodCount: parseInt($('div.exclude-interval input').val())
    excludeInterval: rjm.app.enums.timeInterval[$('div.exclude-interval select').val()]
    type: rjm.app.enums.timeFrameType.MOVING

  validateTimeRange: (include) ->
    $('div.include-interval input').toggleClass("pulse", false)
    $('div.exclude-interval input').toggleClass("pulse", false)
    dateRange = @validationModel.convertRangeToDateObjects()
    start = dateRange.start
    end = dateRange.end
    if end.getTime() <= start.getTime()
      if include
        #update the validation model
        @validationModel.set
          includeInterval: @validationModel.get("excludeInterval")
          includePeriodCount: @validationModel.get("excludePeriodCount") + 1
        #update the ui elements
        @setMovingRangeInterval @validationModel.get("includeInterval"), "include-interval"
        $('div.include-interval input').attr('value', @validationModel.get("includePeriodCount"))
        $('div.include-interval input').toggleClass("pulse", true)
      else
        #update the validation model
        @validationModel.set
          excludeInterval: @validationModel.get("includeInterval")
          excludePeriodCount: if @validationModel.get("includePeriodCount") - 1 >= 0 then @validationModel.get("includePeriodCount") - 1 else 0
        #update the ui elements
        @setMovingRangeInterval @validationModel.get("excludeInterval"), "exclude-interval"
        $('div.exclude-interval input').attr('value', @validationModel.get("excludePeriodCount"))
        $('div.exclude-interval input').toggleClass("pulse", true)
      return false
    true
    
  changeExcludePeriodCount: (e) ->
    @updateValidationModel()
    excludeCount = parseInt($(e.target).val(), 10)
    excludeCount = 0 if excludeCount < 0
    @validationModel.set excludePeriodCount: excludeCount
    @validateTimeRange true
    return

  changeIncludePeriodCount: (e) ->
    @updateValidationModel()
    includeCount = parseInt($(e.target).val(), 10)
    includeCount = 1 if includeCount <= 0
    @validationModel.set includePeriodCount: includeCount
    @validateTimeRange false
    return

  changeIncludeInterval: (e) ->
    @updateValidationModel()
    includeIntervalType = $(e.target).find(":selected").val()
    @validationModel.set includeInterval: rjm.app.enums.timeInterval[includeIntervalType]
    @validateTimeRange false
    return

  changeExcludeInterval: (e) ->
    @updateValidationModel()
    excludeIntervalType = $(e.target).find(":selected").val()
    @validationModel.set excludeInterval: rjm.app.enums.timeInterval[excludeIntervalType]
    @validateTimeRange true
    return

  filterNonNumeric: (event) ->
    
    # Allow: backspace, delete, tab and escape
    # Allow: Ctrl+A
    # Allow: home, end, left, right
    if event.keyCode is 46 or event.keyCode is 8 or event.keyCode is 9 or event.keyCode is 27 or (event.keyCode is 65 and event.ctrlKey is true) or (event.keyCode >= 35 and event.keyCode <= 39)
      # let it happen, don't do anything
      return
    else
      # Ensure that it is a number and stop the keypress
      if (event.keyCode < 48 or event.keyCode > 57) and (event.keyCode < 96 or event.keyCode > 105)
        event.preventDefault()

  setMovingRangeInterval: (value, selector) ->
    selectorPath = 'div.'+selector+' select'

    switch value
      when rjm.app.enums.timeInterval.YEAR then $(selectorPath).find('option[value="YEAR"]').attr('selected', 'selected')
      when rjm.app.enums.timeInterval.QUARTER then $(selectorPath).find('option[value="QUARTER"]').attr('selected', 'selected')
      when rjm.app.enums.timeInterval.MONTH then $(selectorPath).find('option[value="MONTH"]').attr('selected', 'selected')
      when rjm.app.enums.timeInterval.WEEK then $(selectorPath).find('option[value="WEEK"]').attr('selected', 'selected')
      when rjm.app.enums.timeInterval.DAY then $(selectorPath).find('option[value="DAY"]').attr('selected', 'selected')
      when rjm.app.enums.timeInterval.HOUR then $(selectorPath).find('option[value="HOUR"]').attr('selected', 'selected')
  
  generateTemplateData: ->
    
    timeIntervals = {}
    _(rjm.app.enums.timeInterval).each (interval, key) ->
      unless key is "SECOND"
        newInterval = {}
        newInterval.names = interval.names + "(s)"
        timeIntervals[key] = newInterval

    timeIntervals: timeIntervals
    intervalPropertyName: "names"
    excludeInterval: if @model.get("type") is rjm.app.enums.timeFrameType.MOVING then @model.get("excludeInterval").serializedValue else null
    excludePeriodCount: if @model.get("type") is rjm.app.enums.timeFrameType.MOVING then @model.get("excludePeriodCount") else 0
    includeInterval: if @model.get("type") is rjm.app.enums.timeFrameType.MOVING then @model.get("includeInterval").serializedValue else null
    includePeriodCount: if @model.get("type") is rjm.app.enums.timeFrameType.MOVING then @model.get("includePeriodCount") else 0

  render: ->
    $(@el).html ich["chartBuilderTimeOptions.moving"](@generateTemplateData())

    return @
)